export const SideBar = () => {
  return (
    <div className="SideBar">
      <h1>SideBar</h1>
    </div>
  );
};
